(function() {
    "use strict";

    angular.module("dashboardApp").service("RequestWrapper", Service);
    Service.$inject = [
        "$http",
        "$q",
        "$timeout",
        "$window"
    ];


    function Service(
        $http,
        $q,
        $timeout,
        $window
    ) {

        var service = this;

        this.send = function(request, version) {
            var url = request.url;
            var data = request.data;
            var method = request.method || 'GET';
            var timeout = request.timeout;
            var headers = request.headers;

            if (!url) {
                throw('Mandatory "url" property not found.');
            }

            var deferred = $q.defer();

            var config = {
                url: url
            };
            if (data) {
                if (method === 'POST') {
                    config.data = data;
                } else {
                    config.params = data;
                }
            }
            if (method) {
                config.method = method;
            }
            if (headers) {
                config.headers = headers;
            }
            if (timeout) {
                config.timeout = timeout;
            }
            if (version) {
                config.headers = config.headers || {};
                config.headers['X-Data-Version'] = version;
            }

            $http(config).success(function(data) {
                deferred.resolve(data);
            }).error(function(data, status) {
                deferred.reject({
                    data: data,
                    status: status
                });
            });

            return deferred.promise;
        };



        this.getBooleanResponse = function(request) {
            var deferred = $q.defer();

            service.send(request).then(function(response) {
                if (response.result) {
                    deferred.resolve(true);
                } else {
                    deferred.resolve(false);
                }
            }).catch(function(response) {
                deferred.resolve(false);
            });

            return deferred.promise;
        };





    }

})();
